// extracted by mini-css-extract-plugin
module.exports = {"buttonGroup":"buttonGroup_buttonGroup__1dVAh","solo":"buttonGroup_solo__3KHmk"};